import { apiSlice } from '../api/apiSlice';
import {
  CommissionParams,
  CommissionResponse,
  DashboardParams,
  DashboardResponse,
  PayoutParams,
  PayoutResponse,
  PayoutsParams,
  PayoutsResponse,
  ReferralsParams,
  ReferralsResponse,
} from './affiliateApiSliceTypes';

const affiliateApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAffiliateDashboard: builder.query<DashboardResponse, DashboardParams>({
      query: (params) => ({
        url: '/referrals/dashboard',
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
      }),
    }),

    getAffiliatePayout: builder.query<PayoutResponse, PayoutParams>({
      query: (params) => ({
        url: '/referrals/payout-settings',
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
      }),
    }),

    getReferrals: builder.query<ReferralsResponse, ReferralsParams>({
      query: (params) => {
        const { page = 1, limit = 10, ...queryParams } = params ?? {};
        return {
          url: '/referrals/referees',
          method: 'GET',
          headers: {
            'Accept-Language': params.acceptLanguage ?? 'en',
          },
          params: {
            page,
            limit,
            ...queryParams,
          },
        };
      },
    }),

    getCommissions: builder.query<CommissionResponse, CommissionParams>({
      query: (params) => {
        return {
          url: `referrals/referees/${params.referredUserId}/commissions`,
          method: 'GET',
          headers: {
            'Accept-Language': params.acceptLanguage ?? 'en',
          },
        };
      },
    }),

    getPayouts: builder.query<PayoutsResponse, PayoutsParams>({
      query: (params) => {
        const { page = 1, limit = 10, ...queryParams } = params ?? {};
        return {
          url: '/referrals/payouts',
          method: 'GET',
          headers: {
            'Accept-Language': params.acceptLanguage ?? 'en',
          },
          params: {
            page,
            limit,
            ...queryParams,
          },
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetAffiliateDashboardQuery,
  useLazyGetAffiliateDashboardQuery,
  useGetReferralsQuery,
  useLazyGetReferralsQuery,
  useGetCommissionsQuery,
  useLazyGetCommissionsQuery,
  useGetAffiliatePayoutQuery,
  useLazyGetAffiliatePayoutQuery,
  useGetPayoutsQuery,
  useLazyGetPayoutsQuery,
} = affiliateApiSlice;
